<section #procesos class="procesos mt-3">
    <div class="row">
        <!-- Activaciones -->
        <div class="col-xl-12" *ngIf="!activationsByMonthError">
            <div class="card--sidebar mb-3">
                <div class="card-footer--sidebar-kpi1">
                    <div class="row kpi-col" *ngIf="activationStatistics">
                        <div class="col-md-3 ps-4 mb-2 d-flex align-items-center flex-column" *ngIf="permSv.hasPermFromV2(allPermissions.simyo.permite_vender_broadband)">
                            <div class="cursor-pointer" (click)="viewOperation(typeFilterFormOperation.totalActivationsFibra)">
                                <span class="title-p3 me-2">Fibra:</span>
                                <span class="kpi2">{{ activationStatistics.countActualMonthFibra }}</span>
                            </div>
                            <div>
                                <span title="Estimación a final de mes"
                                  [ngClass]="{'kpi-per-positive2' : activationStatistics.estimatedFibra > 0, 'kpi-per-negative2': activationStatistics.estimatedFibra < 0, 'kpi-per-neutro2': activationStatistics.estimatedFibra === 0 }">
                                {{ getAbsoluteValue(activationStatistics.estimatedFibra) }}%
                                </span>
                                <span class="kpi-per-mes1 me-1">- {{ monthNames[lastMonth] }}:</span>
                                <span class="kpi-a1">{{ activationStatistics.countPreviousMonthFibra }}</span>
                            </div>

                        </div>
                        <div class="ps-4 mb-2 border-start d-flex align-items-center flex-column" [ngClass]="{'col-md-3': permSv.hasPermFromV2(allPermissions.simyo.permite_vender_broadband), 'col-md-4': !permSv.hasPermFromV2(allPermissions.simyo.permite_vender_broadband)}">
                            <div class="cursor-pointer" (click)="viewOperation(typeFilterFormOperation.totalActivationsPostpago)">
                                <span class="title-p3 me-2">Pospago:</span>
                                <span class="kpi2">{{ activationStatistics.countActualMonthPospago }}</span>
                            </div>
                            <div>
                                <span title="Estimación a final de mes"
                                  [ngClass]="{'kpi-per-positive2' : activationStatistics.estimatedPospago > 0, 'kpi-per-negative2': activationStatistics.estimatedPospago < 0, 'kpi-per-neutro2': activationStatistics.estimatedPospago === 0 }">
                                {{ getAbsoluteValue(activationStatistics.estimatedPospago) }}%
                                </span>
                                <span class="kpi-per-mes1 me-1">- {{ monthNames[lastMonth] }}:</span>
                                <span class="kpi-a1">{{ activationStatistics.countPreviousMonthPospago }}</span>
                            </div>

                        </div>
                        <div class="ps-4 mb-2 border-start d-flex align-items-center flex-column" [ngClass]="{'col-md-3': permSv.hasPermFromV2(allPermissions.simyo.permite_vender_broadband), 'col-md-4': !permSv.hasPermFromV2(allPermissions.simyo.permite_vender_broadband)}">
                            <div class="cursor-pointer" (click)="viewOperation(typeFilterFormOperation.totalActivationsPrepago)">
                                <span class="title-p3 me-2">Prepago:</span>
                                <span class="kpi2">{{ activationStatistics.countActualMonthPrepago }}</span>
                            </div>
                            <div>
                                <span title="Estimación a final de mes"
                                [ngClass]="{'kpi-per-positive2' : activationStatistics.estimatedPrepago > 0, 'kpi-per-negative2': activationStatistics.estimatedPrepago < 0, 'kpi-per-neutro2': activationStatistics.estimatedPrepago === 0 }">
                              {{ getAbsoluteValue(activationStatistics.estimatedPrepago) }}%
                                </span>
                                <span class="kpi-per-mes1 me-1">- {{ monthNames[lastMonth] }}:</span>
                                <span class="kpi-a1">{{ activationStatistics.countPreviousMonthPrepago }}</span>
                            </div>
                        </div>
                        <div align="center" class="ps-4 pt-1 mb-2 border-start d-flex align-items-center flex-column"
                             [ngClass]="{'col-md-3': permSv.hasPermFromV2(allPermissions.simyo.permite_vender_broadband), 'col-md-4': !permSv.hasPermFromV2(allPermissions.simyo.permite_vender_broadband)}">
                            <div><img src="./assets/img/saldo.svg" class="img-fluid avisos--sidebar--icon" width="16"> Total este mes:</div>
                            <span class="orange ms-0 cursor-pointer" (click)="viewOperation(typeFilterFormOperation.totalActivationsMonth)">
                                <b>{{ activationStatistics.countActualMonthFibra + activationStatistics.countActualMonthPospago + activationStatistics.countActualMonthPrepago }}</b> activaciones
                            </span>
                        </div>
                    </div>
                    <div style="padding-bottom: 5px;" *ngIf="!activationStatistics">
                        <h5 class="tar-name-preload text-center">
                            <img class="" src="./assets/img/spinner-home.svg" width="30" alt=""> Obteniendo activaciones...
                        </h5>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl-12" *ngIf="activationsByMonthError">
            <div class="card--sidebar mb-3">
                <div class="card-footer--sidebar-kpi1">
                    <h5 class="tar-name-preload text-center" style="padding-bottom: 5px;">Se ha producido un error, inténtalo de nuevo más tarde</h5>
                </div>
            </div>
        </div>

        <!-- MARCAS -->
        <div class="col-xl-7 ps-lg-4">
            <div class="accordion subpage_top_nav" id="accordionExample">
                <ul class="d-flex flex-column list-brands">
                    <li class="brand" *ngFor="let hmBrand of hmBrands; let i = index" [ngClass]="getBrandClass(hmBrand, i)">
                        <app-hm-brand [brand]="hmBrand"></app-hm-brand>
                    </li>
                </ul>
            </div>
            <ng-container
                *ngIf="(permSv.hasPermFromV2(allPermissions.others.comissions_permitir) || permSv.hasPermFromV2(allPermissions.others.comissions_pend_doc) || permSv.hasPermFromV2(allPermissions.others.comissions_pend_verificacion)) && pdv?.info?.tipo_vista !== PDV_MULTIMARCA; then recargasYpedidos">
            </ng-container>
        </div>
        <!-- MARCAS -->

        <!-- OTROS PROCESOS -->
        <div class="col-xl-5">
            <div class="banners_group">
                <div *ngIf="brandOpened === brands.simyo">
                    <!-- banner ads -->
                    <div class="banner--ads--sidebar-sm mb-3 fade-in">
                        <ngb-carousel class="container px-0"
                                      *ngIf="(today.isBefore(smChangeGif)) || today.isSameOrAfter(smGifFinish) || (!environment.production && pdv?.info?.username === 'demo_pdv' && (smChangeGif.isSameOrAfter(today) || today.isBefore(smGifFinish)))">
                            <ng-template ngbSlide>
                                <img [src]="getBannerSimyo()" class="img-fluid">
                            </ng-template>
                        </ngb-carousel>
                        <span *ngIf="!environment.production && pdv?.info?.username === 'demo_pdv' && (smChangeGif.isSameOrAfter(today) || today.isBefore(smGifFinish))">
                             A partir del día {{ smChangeGif.format('DD/MM/YYYY') }} {{ today.isBefore(smGifFinish) ? 'hasta el día ' + smGifFinish?.format('DD/MM/YYYY') : '' }} se muestra el banner de abajo
                        </span>
                        <ngb-carousel class="container px-0"
                                      *ngIf="(today.isSameOrAfter(smChangeGif) && today.isBefore(smGifFinish)) || (!environment.production && pdv?.info?.username === 'demo_pdv' && (smChangeGif.isSameOrAfter(today) || today.isBefore(smGifFinish)))">
                            <ng-template ngbSlide>
                                <img [src]="getBannerSimyo()" class="img-fluid">
                            </ng-template>
                        </ngb-carousel>
                    </div>
                </div>

                <div *ngIf="brandOpened === brands.orange">
                    <!-- banner ads -->
                    <div class="banner--ads--sidebar-or mb-3 fade-in">
                        <ngb-carousel [showNavigationIndicators]="pdv?.banners?.image_orange?.images.length > 1" class="container px-0" *ngIf="pdv?.banners?.image_orange && !pdv?.banners?.image_orange?.error">
                            <ng-template ngbSlide *ngFor="let banner of pdv?.banners?.image_orange?.images">
                                <img [src]="'data:image/gif;base64,' + banner" class="img-fluid">
                            </ng-template>
                        </ngb-carousel>
                        <!-- <img *ngIf="pdv?.banners?.image_orange && !pdv?.banners?.image_orange?.error" [src]="'data:image/gif;base64,' + pdv?.banners?.image_orange?.image" class="img-fluid"> -->
                        <img *ngIf="!pdv?.banners || pdv?.banners?.image_orange?.error" src="./assets/img/Banner_DIGO_Mundo_445x300_0421_V2.gif" class="img-fluid">
                    </div>
                </div>

                <div *ngIf="brandOpened === brands.jazztel">
                    <!-- banner ads -->
                    <div class="banner--ads--sidebar-am mb-3 fade-in">
                        <ngb-carousel class="container px-0">
                            <ng-template ngbSlide>
                                <img src="./assets/img/banners/current/banner_jazztel.jpg" class="img-fluid" alt="Jazztel">
                            </ng-template>
                        </ngb-carousel>
                    </div>
                </div>

                <div *ngIf="brandOpened === brands.masmovil">
                    <!-- banner ads -->
                    <div class="banner--ads--sidebar-am mb-3 fade-in">
                        <ngb-carousel class="container px-0">
                            <ng-template ngbSlide>
                                <img src="./assets/img/banners/current/banner_masmovil_03-02-2025.jpg" class="img-fluid" alt="MásMóvil">
                            </ng-template>
                        </ngb-carousel>
                    </div>
                </div>

                <div *ngIf="brandOpened === brands.guuk">
                    <!-- banner ads -->
                    <div class="banner--ads--sidebar-am mb-3 fade-in">
                        <ngb-carousel class="container px-0">
                            <ng-template ngbSlide>
                                <img src="./assets/img/banners/current/banner_guuk.jpg" class="img-fluid" alt="Guuk">
                            </ng-template>
                        </ngb-carousel>
                    </div>
                </div>

                <div *ngIf="brandOpened === brands.pepephone">
                    <!-- banner ads -->
                    <div class="banner--ads--sidebar-am mb-3 fade-in">
                        <ngb-carousel class="container px-0">
                            <ng-template ngbSlide>
                                <img src="./assets/img/banners/current/banner_pepephone.jpg" class="img-fluid" alt="Pepephone">
                            </ng-template>
                        </ngb-carousel>
                    </div>
                </div>
            </div>
            
            <div>
                <ng-container *ngIf="showIncentivePending && permSv.hasPermFromV2(allPermissions.others.access_points) && permSv.hasPermFromV2(allPermissions.others.access_night)">
                    <div class="new-incentive-container">

                        <img src="./assets/img/present.png" alt="Regalo" class="present-banner"/>

                        <div class="">
                            <div class="new-incentive-banner-text">
                                ¡Tienes disponible un nuevo incentivo!
                            </div>
                            <a class="noshow-incentive-banner" (click)="hideIncentiveBanner()">
                                No volver a mostrar
                            </a>
                        </div>
                        <button type="button" class="close-incentive-img-banner" aria-label="Cerrar" (click)="hideIncentiveBanner()">
                                <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                </ng-container>
            </div>



            <!-- Comisiones -->
            <ng-template
                *ngIf="(permSv.hasPermFromV2(allPermissions.others.comissions_permitir) || permSv.hasPermFromV2(allPermissions.others.comissions_pend_doc) || permSv.hasPermFromV2(allPermissions.others.comissions_pend_verificacion)) && pdv?.info?.tipo_vista !== PDV_MULTIMARCA && permSv.hasPermFromV2(allPermissions.others.access_night); then comisiones">
            </ng-template>

            <!-- Comisiones -->
            <ng-template *ngIf="permSv.hasPermFromV2(allPermissions.others.access_points) && permSv.hasPermFromV2(allPermissions.others.access_night); then points">
            </ng-template>

            <ng-template *ngIf="pdv?.info?.tipo_vista === PDV_MULTIMARCA && permSv.hasPermFromV2(allPermissions.others.terminales_libres); then terminalesLibres">
            </ng-template>

            <ng-template
                *ngIf="!(permSv.hasPermFromV2(allPermissions.others.comissions_permitir) || permSv.hasPermFromV2(allPermissions.others.comissions_pend_doc) || permSv.hasPermFromV2(allPermissions.others.comissions_pend_verificacion)) && pdv?.info?.tipo_vista !== PDV_MULTIMARCA; then recargasYpedidos">
            </ng-template>
        </div>
    </div>
</section>

<ng-template #recargasYpedidos id="orders_and_credit_phone">
    <div [class.form-row]="(permSv.hasPermFromV2(allPermissions.others.comissions_permitir) || permSv.hasPermFromV2(allPermissions.others.comissions_pend_doc) || permSv.hasPermFromV2(allPermissions.others.comissions_pend_verificacion))">
        <div
            [ngClass]="{'col-xl-12 p-0': !(permSv.hasPermFromV2(allPermissions.others.comissions_permitir) || permSv.hasPermFromV2(allPermissions.others.comissions_pend_doc) || permSv.hasPermFromV2(allPermissions.others.comissions_pend_verificacion)), 'col-xl-6': (permSv.hasPermFromV2(allPermissions.others.comissions_permitir) || permSv.hasPermFromV2(allPermissions.others.comissions_pend_doc) || permSv.hasPermFromV2(allPermissions.others.comissions_pend_verificacion)) }"
            *ngIf="pdv != null && ((permSv.hasPermFromV2(allPermissions.others.recharges_permite_saldo_promocional) && pdv.info_recargas.saldo_promo && pdv.info_recargas.saldo_promo > 0) || (!permSv.hasPermFromV2(allPermissions.others.recharges_bloquea_saldo_dexga)))">
            <div class="card--sidebar mb-3">
                <div class="card-header--sidebar">
                    Recarga de saldo
                </div>
                <div class="card-body--sidebar">
                    <div class="row">
                        <div class="col-12 col-md pt-1 pe-0">
                            <img src="./assets/img/saldo.svg" class="img-fluid avisos--sidebar--icon" width="16">
                            <span *ngIf="!permSv.hasPermFromV2(allPermissions.others.recharges_bloquea_saldo_dexga) && +pdv.info_recargas.usuario_dexga > 0">
                                Saldo: <span class="orange">{{ (+pdv.info_recargas.saldo_promo + +pdv.info_recargas.saldo_dexga).toFixed(2) }}</span> €
                            </span>
                            <span *ngIf="!permSv.hasPermFromV2(allPermissions.others.recharges_bloquea_saldo_dexga) && +pdv.info_recargas.usuario_dexga === 0">
                                Habilita el sistema de recargas
                            </span>
                        </div>
                        <div class="col-12 col-md-auto mobile--ver--sidebar align-self-center" *ngIf="!permSv.hasPermFromV2(allPermissions.others.recharges_bloquea_saldo_dexga) && +pdv.info_recargas.usuario_dexga > 0">
                            <a href="{{ baseUrl }}recargas_dexga_gestion.itx" class="btn btn-black-sidebar btn-sm">Mi cuenta</a>
                        </div>
                        <div class="col-12 col-md-auto mobile--ver--sidebar align-self-center" *ngIf="!permSv.hasPermFromV2(allPermissions.others.recharges_bloquea_saldo_dexga) && +pdv.info_recargas.usuario_dexga === 0">
                            <a href="{{ baseUrl }}recargas_dexga_sol_usuario.itx" class="btn btn-black-sidebar btn-sm">Solicitar</a>
                        </div>
                    </div>
                </div>
                <div class="card-footer--sidebar"
                     *ngIf="(permSv.hasPermFromV2(allPermissions.others.recharges_permite_saldo_promocional) && +pdv.info_recargas.saldo_promo > 0) || (!permSv.hasPermFromV2(allPermissions.others.recharges_bloquea_saldo_dexga) &&+ pdv.info_recargas.usuario_dexga > 0)">
                    <a href="{{ baseUrl }}recarga_saldo_origen.itx" class="btn btn-black--outline btn-sm d-block w-100"
                       *ngIf="permSv.hasPermFromV2(allPermissions.others.recharges_permite_saldo_promocional) && +pdv.info_recargas.saldo_promo > 0 && !permSv.hasPermFromV2(allPermissions.others.recharges_bloquea_saldo_dexga) && +pdv.info_recargas.usuario_dexga > 0">
                        Hacer una recarga
                    </a>
                    <a href="{{ baseUrl }}recarga_saldo.itx" class="btn btn-black--outline btn-sm d-block w-100"
                       *ngIf="permSv.hasPermFromV2(allPermissions.others.recharges_permite_saldo_promocional) && +pdv.info_recargas.saldo_promo > 0 && +pdv.info_recargas.usuario_dexga === 0">
                        Hacer una recarga
                    </a>
                    <a href="{{ baseUrl }}recargas_dexga_recarga.itx" class="btn btn-black--outline btn-sm d-block w-100"
                       *ngIf="!permSv.hasPermFromV2(allPermissions.others.recharges_bloquea_saldo_dexga) && +pdv.info_recargas.usuario_dexga > 0 && +pdv.info_recargas.saldo_promo === 0">
                        Hacer una recarga
                    </a>
                    <a href="{{ baseUrl }}bolsas_recarga_reparto.itx" class="btn btn-black--outline btn-sm d-block w-100"
                       *ngIf="!permSv.hasPermFromV2(allPermissions.others.recharges_bloquea_saldo_dexga) && pdv.info_recargas.usuario_dexga > 0 && pdv.info_recargas.bolsa_saldo === 1">
                        Gestión bolsa de saldo
                    </a>
                </div>
            </div>
        </div>

        <div
            [ngClass]="{'col-xl-12 p-0': !(permSv.hasPermFromV2(allPermissions.others.comissions_permitir) || permSv.hasPermFromV2(allPermissions.others.comissions_pend_doc) || permSv.hasPermFromV2(allPermissions.others.comissions_pend_verificacion)), 'col-xl-6': (permSv.hasPermFromV2(allPermissions.others.comissions_permitir) || permSv.hasPermFromV2(allPermissions.others.comissions_pend_doc) || permSv.hasPermFromV2(allPermissions.others.comissions_pend_verificacion)) }"
            *ngIf="permSv.hasPermFromV2(allPermissions.orange.permite_ventas_prepago) || permSv.hasPermFromV2(allPermissions.orange.permite_ventas_pospago)">
            <div class="card--sidebar mb-3">
                <div class="card-header--sidebar">
                    Pedidos
                </div>
                <div class="card-body--sidebar">
                    <div class="row">
                        <div class="col-12 col-md pt-1">
                            <img src="./assets/img/iconinvoice.svg" class="img-fluid avisos--sidebar--icon" width="16">
                            Albaranes
                        </div>
                        <div class="col-12 col-md-auto mobile--ver--sidebar">
                            <a href="{{ baseUrl }}app_albaran_pdv.itx" class="btn btn-black-sidebar btn-sm">Acceder</a>
                        </div>
                    </div>
                </div>

                <div class="card-footer--sidebar">
                    <a href="{{ baseUrl }}pedido_pdv.itx" class="btn btn-black--outline btn-sm d-block w-100">
                        <strong>Hacer un pedido</strong>
                    </a>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #comisiones id="commissions">
    <div class="card--sidebar mb-3">
        <div class="card-header--sidebar custom-background">
            Comisiones
        </div>
        <div class="card-body--sidebar">
            <div class="row" *ngIf="permSv.hasPermFromV2(allPermissions.others.comissions_permitir)">
                <div class="col-12 col-md pt-1">
                    <img src="./assets/img/euro.svg" class="img-fluid avisos--sidebar--icon" width="16">
                    Revisa tus comisiones
                </div>
                <div class="col-12 col-md-auto mobile--ver--sidebar">
                    <a (click)="viewCommissions()" class="btn btn-black-sidebar btn-sm">Consultar</a>
                </div>
            </div>

            <div class="row" *ngIf="permSv.hasPermFromV2(allPermissions.others.comissions_pend_doc)">
                <div class="col-12 col-md pt-1">
                    <img src="./assets/img/euro.svg" class="img-fluid avisos--sidebar--icon" width="16">
                    Únete al programa de comisiones
                </div>
                <div class="col-12 col-md-auto mobile--ver--sidebar">
                    <a href="{{ baseUrl }}comision_empresa.itx" class="btn btn-black-sidebar btn-sm">Gestionar</a>
                </div>
            </div>

            <div class="row" *ngIf="permSv.hasPermFromV2(allPermissions.others.comissions_pend_verificacion)">
                <div class="col-12 col-md pt-1">
                    <img src="./assets/img/euro.svg" class="img-fluid avisos--sidebar--icon" width="16">
                    Tu documentación está siendo validada
                </div>
            </div>
        </div>
        <ng-container *ngIf="permSv.hasPermFromV2(allPermissions.others.comissions_permitir) && (permSv.hasPermFromV2(allPermissions.jazztel.permite_ventas) || permSv.hasPermFromV2(allPermissions.simyo.permite_vender))">
            <ng-container *ngIf="rappelSimyoData">
                <div class="card-footer--sidebar" *ngIf="rappelSimyoData.mensual">
                    <div *ngIf="rappelSimyoData.mensual.current">
                            <div class="row mb-2" *ngIf="!rappelSimyoData.mensual?.current?.text || rappelSimyoData.mensual?.current?.text.includes('Sin categ'); else showCurrentTextMensual">
                                <div class="col-12">
                                    <b class="font--tramos">Tramo mensual: <b class="orange">{{ rappelSimyoData.mensual?.current?.text || 'Sin ventas' }}</b></b>
                                </div>
                                <div class="col-7">
                                    <span>
                                        <b class="orange mt-2" class="month--styles">{{ monthNames[today.month()] }} </b>
                                        <span class="badge badge-warning-orange">{{ rappelSimyoData.mensual.current.current_activations }} activaciones</span>
                                    </span>
                                    <br>
                                </div>
                            </div>
                            <ng-template #showCurrentTextMensual>
                                <div class="row">
                                    <div class="col-9">
                                        <span>
                                            <b class="font--tramos">Tramo mensual: <b class="orange">{{ rappelSimyoData.mensual?.current?.text || 'Sin ventas' }}</b></b>
                                            <br>
                                            <b class="month--styles mt-2">{{ monthNames[today.month()] }} </b>
                                            <span class="badge badge-warning-orange">{{ rappelSimyoData.mensual.current.current_activations }} activaciones</span>
                                        </span>
                                        <div class="progress progress-container mt-1">
                                            <div class="progress-bar-comissions progress-bar-striped progress-bar-animated" role="progressbar" [ngStyle]="{ 'width.%': getWidth(rappelSimyoData.mensual) }" aria-valuenow="55" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                    </div>
                                    <div class="col-3 text-center d-flex align-items-end justify-content-center">
                                        <img *ngIf="getCurrentLogoRappel()" [src]="getCurrentLogoRappel()" class="img-fluid" [width]="getLogoWidth()">
                                    </div>
                                </div>
                            </ng-template>
                        <small class="text-muted" *ngIf="rappelSimyoData?.mensual.current?.next_level">
                            Te quedan <b>{{ rappelSimyoData.mensual.current.next_level.min_activations - rappelSimyoData.mensual.current.current_activations }}</b> activaciones para pasar a la categoría <span
                            class="orange">{{ rappelSimyoData.mensual.current.next_level.text }}</span><br>
                        </small>
                        <ng-container *ngIf="today?.date() > dayToShowCategoryRappelPreviousMonth">
                            <small class="text-muted">
                                Categoría mes anterior <b class="orange">{{ (pdv.info.clasificacion || 'Sin ventas')|titlecase }}</b>
                            </small>
                        </ng-container>
                    </div>
                </div>

                <div class="card-footer--sidebar" style="border-top: 5px solid #eee;" *ngIf="rappelSimyoData.bimensual">
                    <div *ngIf="rappelSimyoData.bimensual.current">
                            <div class="row" *ngIf="!rappelSimyoData.bimensual?.current?.text || rappelSimyoData.bimensual?.current?.text.includes('Sin categ'); else showCurrentText">
                                <div class="col-12">
                                    <span>
                                        <b class="font--tramos">Tramo bimestral: <b class="orange">{{ rappelSimyoData.bimensual?.current?.text || 'Sin ventas' }} </b></b>
                                    </span>
                                    <br>
                                </div>
                                <div class="col-7">
                                    <ng-container *ngIf="rappelSimyoData.bimensual.current.activations_per_month | keyvalue: keyvalueOriginalOrder as months">
                                        <ng-container *ngFor="let month of months; let i = index">
                                            <b [ngClass]="{'orange': true, 'mt-1': i===0}" class="month--styles">{{ month.key }} </b>
                                            <span [ngClass]="{'badge': true, 'badge-warning-orange': rappelSimyoData.bimensual.current.are_there_activations_in_both_months, 'badge-warning-grey': !rappelSimyoData.bimensual.current.are_there_activations_in_both_months}">
                                                {{ month.value }} activaciones
                                            </span>
                                        </ng-container>
                                    </ng-container>
                                </div>
                                <!-- <div class="col-5 pr-0 pl-0 style--logos" align="right">
                                    <img src="./assets/img/sm-login-color.svg" class="img-fluid logo--tarifa mr-1" width="70" *ngIf="permSv.hasPermFromV2(allPermissions.simyo.permite_vender)">
                                    <img src="./assets/img/jz-login-color.svg" class="img-fluid logo--tarifa mb-1 mr-1" width="70" *ngIf="permSv.hasPermFromV2(allPermissions.jazztel.permite_ventas)">
                                    <img src="./assets/img/mm-login-color.svg" class="img-fluid logo--tarifa" style="margin-bottom: 1px;" width="70" *ngIf="permSv.hasPermFromV2(allPermissions.masmovil.vende_masmovil)">
                                    <img src="./assets/img/pp-login-color.svg" class="img-fluid logo--tarifa mb-1 img--pp-gk" width="90" *ngIf="permSv.hasPermFromV2(allPermissions.pepephone.vende_pepephone)">
                                    <img src="./assets/img/gk-login-color.svg" class="img-fluid logo--tarifa img--pp-gk" width="70" *ngIf="permSv.hasPermFromV2(allPermissions.guuk.vende_guuk)">
                                </div> -->
                            </div>
                            <ng-template #showCurrentText>
                                <div class="row">
                                    <div class="col-9" style="padding-right: 40px;">
                                        <span>
                                            <b class="font--tramos">Tramo bimestral: <b class="orange">{{ rappelSimyoData.bimensual?.current?.text || 'Sin ventas' }} </b></b>
                                            <div *ngIf="rappelSimyoData.bimensual.current.activations_per_month | keyvalue: keyvalueOriginalOrder as months" class="mt-2">
                                                <ng-container *ngFor="let month of months; let i = index">
                                                    <b class="month--styles">{{ month.key }} </b>
                                                    <span [ngClass]="{'badge': true, 'badge-warning-orange': rappelSimyoData.bimensual.current.are_there_activations_in_both_months, 'badge-warning-grey': !rappelSimyoData.bimensual.current.are_there_activations_in_both_months}">
                                                        {{ month.value }} activaciones
                                                    </span>
                                                </ng-container>
                                            </div>
                                        </span>
                                         <div class="progress progress-container mt-1" *ngIf="rappelSimyoData.bimensual.current.are_there_activations_in_both_months">
                                            <div class="progress-bar-comissions progress-bar-striped progress-bar-animated" role="progressbar" [ngStyle]="{ 'width.%': getWidth(rappelSimyoData.bimensual) }" aria-valuenow="55" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                    </div>
                                    <div class="col-3 pt-2 text-center d-flex align-items-end justify-content-center">
                                        <img *ngIf="getCurrentLogoRappel(true)" [src]="getCurrentLogoRappel(true)" class="img-fluid" [width]="getLogoWidth(true)">
                                    </div>
                                </div>
                            </ng-template>
                        <ng-container *ngIf="rappelSimyoData.bimensual.current.are_there_activations_in_both_months">
                            <small class="text-muted" *ngIf="rappelSimyoData?.bimensual.current?.next_level">
                                Te quedan <b>{{ rappelSimyoData.bimensual.current.next_level.min_activations - rappelSimyoData.bimensual.current.current_activations }}</b> activaciones para pasar al tramo bimestral <span
                                class="orange">{{ rappelSimyoData.bimensual.current.next_level.text }}</span>
                            </small>
                        </ng-container>
                        <div *ngIf="!rappelSimyoData.bimensual.current.are_there_activations_in_both_months">
                            <div class="info-rappel-bimensual">
                                <div class="mt-1">
                                    <img src="./assets/img/info.svg" class="icon-info-rapper" width="18" >
                                </div>
                                <div style="font-size: 12px; font-weight: bold; padding-right: 10px;">Recuerda que debes tener activaciones en los dos meses para conseguir el rappel</div>
                            </div>
                        </div>
                        <ng-container *ngIf="today?.date() > dayToShowCategoryRappelPreviousMonth">
                            <small class="text-muted">
                                Categoría bimestral anterior <b class="orange">{{ (pdv.info.clasificacion_bimensual || 'Sin ventas')|titlecase }}</b>
                            </small>
                        </ng-container>
                    </div>
                </div>
            </ng-container>
            <div *ngIf="!rappelSimyoData && !rappelSimyoDataError" class="col-xl-12 card-footer--sidebar">
                <div class="mt-2">
                    <div class="my-5">
                        <h5 class="tar-name-preload text-center">Obteniendo rappel...</h5>
                        <div class="d-flex justify-content-center">
                            <img class="" src="./assets/img/spinner-home.svg" width="30" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="rappelSimyoDataError">
                <h5 class="tar-name-preload text-center">Se ha producido un error, inténtalo de nuevo más tarde</h5>
            </div>
        </ng-container>
    </div>
</ng-template>

<ng-template #points id="points">
    <div class="card--sidebar mb-3">
        <div class="card-header--sidebar custom-background">
            <img src="./assets/img/img_atrevete.svg" alt="Atrévete" height="25" style="margin-right: 10px;">
            Más ventas, más premios
        </div>
        <div class="card-body--sidebar">
            <div class="row" *ngIf="pointsService.checkIsAcceptedPointsProgram(pdv.info.points_terms)">
                <div class="col-12 col-md pt-1" *ngIf="dataPoints">
                    <b class="title-points orange">{{ dataPoints.pointsAvailable }} </b>
                    Puntos disponibles
                </div>
                <div class="col-12 col-md-auto mobile--ver--sidebar">
                    <a (click)="viewPoints()" class="btn btn-black-sidebar btn-sm">Ver puntos</a>
                </div>
            </div>

            <div class="row" *ngIf="pointsService.checkIsAcceptedPointsProgram(pdv.info.points_terms) === false">
                <div class="col-12 col-md pt-1">
                    <i-feather name="gift" class="icon--fe"></i-feather>
                    Únete al programa de puntos
                </div>
                <div class="col-12 col-md-auto mobile--ver--sidebar">
                    <a (click)="viewPoints()" class="btn btn-black-sidebar btn-sm">Gestionar</a>
                </div>
            </div>
        </div>
        <ng-container *ngIf="pointsService.checkIsAcceptedPointsProgram(pdv.info.points_terms)">

            <div class="card-footer--sidebar" *ngIf="resumeData?.length">
            <ngb-carousel
                [wrap]="true"
                [keyboard]="true"
                [pauseOnHover]="true"
                [showNavigationIndicators]="true"
                class="mb-2 dark-carousel"
            >
                <ng-template ngbSlide *ngFor="let inc of resumeData; let i = index" id="inc-{{ i }}">

                <div class="p-3">
                      <label class="inc-name-resume mb-2">{{inc.name}}</label>
                      <ng-container *ngIf="inc.total_objetive">
                            <div class="row mx-0 no-gutters mb-2" style="column-gap: 6px;">
                                <div class="col p-0 text-center">
                                    <div class="obj-points-container" style="margin-right: 2px;">
                                        <span class="obj-points">
                                            Objetivo
                                            <span *ngIf="inc.keyname === 'one_shot' && inc.objective_pospaid > 0"> Pospago</span>
                                            <span *ngIf="inc.keyname === 'one_shot' && inc.objective_fix > 0"> Fijo</span>
                                            <span *ngIf="inc.keyname === 'one_shot' && inc.objective_value > 0"> Valor</span>
                                        </span>
                                        <span class="totals-incentives-obj-font">{{inc.total_objetive}}</span>
                                    </div>
                                </div>
                                <div class="col p-0 text-center" *ngIf="inc.activations_to_objetive > 0 || inc.keyname !== 'one_shot'">
                                    <div class="obj-points-container">
                                        <span class="obj-points">Actual</span> <span class="totals-incentives-obj-font">{{inc.actual_activations}}</span>
                                    </div>
                                </div>
                            </div>

                            <small *ngIf="inc.keyname !== 'incremental' && inc.keyname !== 'one_shot'" class="text-muted">
                                Estás a solo <span style="font-weight: bold;">{{inc.activations_to_objetive}} altas</span> de conseguir por cada alta hasta <b>{{ getMaxIncentive(i) }} puntos</b>. <br>
                                <span *ngIf="inc.date_end">Date prisa, tienes hasta el {{inc.date_end | date: 'dd/MM/yyyy'}} para conseguirlo</span>
                            </small>

                            <small *ngIf="inc.keyname == 'incremental'" class="text-muted">
                                Con cada <b>alta extra</b> al objetivo conseguirás hasta <span style="font-weight: bold;">{{ getMaxIncentive(i) }} puntos.</span> <br>
                                <span *ngIf="inc.date_end">Date prisa, tienes hasta el {{inc.date_end | date: 'dd/MM/yyyy'}} para conseguirlo</span>
                            </small>

                            <small *ngIf="inc.keyname == 'one_shot'" class="text-muted">
                                <ng-container *ngIf="inc.activations_to_objetive != 0 && inc.activations_to_objetive != null">
                                    Estás a <span style="font-weight: bold;">{{inc.activations_to_objetive}} {{inc.activations_to_objetive === 1 ? 'alta' : 'altas' }}</span>
                                    {{ +inc.objective_value > 0 ? '(fijo o pospago)' : '' }}
                                    de conseguir <b>{{(+inc.points_objective_fix) + (+inc.points_objective_pospaid) + (+inc.points_objective_value) }} puntos</b>.
                                </ng-container>
                               <ng-container *ngIf="inc.activations_to_objetive == 0">
                                    Objetivo cumplido, has obtenido <b>{{inc.points}} puntos</b>.
                                </ng-container>
                            </small>

                      </ng-container>

                       <ng-container *ngIf="!inc.total_objetive">
                         <div  class="img-wrapper text-center">
                            <img *ngIf="inc.image" [src]="inc.image" alt="Incentivo sin objetivo" class="fixed-height-img">
                            <img *ngIf="!inc.image" src="./assets/img/img_atrevete_incentive_default2.jpg" alt="Incentivo" class="fixed-height-img"/>
                        </div>
                        <div class="mt-2" style="display: grid;">
                            <small  class="text-muted">
                                Llevas <span style="font-weight: bold;">{{inc.points ?? '0'}} puntos</span> conseguidos
                            </small>
                            <small *ngIf="inc.date_end" class="text-muted">
                                Date prisa, tienes hasta el {{inc.date_end | date: 'dd/MM/yyyy'}} para conseguirlo
                            </small>
                        </div>
                       </ng-container>

                        <div style="background-color: white;height: 10px;margin-bottom: 20px;margin-top: 10px;"></div>
                </div>
                </ng-template>
            </ngb-carousel>
            </div>

            <div *ngIf="dataPointsError">
                <h5 class="tar-name-preload text-center">Se ha producido un error, inténtalo de nuevo más tarde</h5>
            </div>
        </ng-container>
    </div>
</ng-template>

<ng-template #terminalesLibres id="free_terminals">
    <div class="card--sidebar mb-3" *ngIf="pdv?.info?.tipo_vista === PDV_MULTIMARCA && permSv.hasPermFromV2(allPermissions.others.terminales_libres)">
        <div class="card-header--sidebar">
            Terminales libres
        </div>

        <div>
            <div class="card-footer--sidebar row ms-0">
                <div class="col-12 col-md pt-1">
                    <img src="./assets/img/phone_home.svg" class="img-fluid avisos--sidebar--icon" width="16">
                    Venta de terminales
                </div>
                <div class="col-12 col-md-auto mobile--ver--sidebar">
                    <a href="{{ baseUrl }}tlib_activa.itx" class="btn btn-black-sidebar btn-sm">Acceder</a>
                </div>
            </div>
            <div class="card-footer--sidebar row ms-0">
                <div class="col-12 col-md pt-1">
                    <img src="./assets/img/phone_home.svg" class="img-fluid avisos--sidebar--icon" width="16">
                    Consulta tus ventas
                </div>
                <div class="col-12 col-md-auto mobile--ver--sidebar">
                    <a href="{{ baseUrl }}tlib_recogida_pdv.itx" class="btn btn-black-sidebar btn-sm">Acceder</a>
                </div>
            </div>
            <div class="card-footer--sidebar row ms-0">
                <div class="col-12 col-md pt-1">
                    <img src="./assets/img/phone_home.svg" class="img-fluid avisos--sidebar--icon" width="16">
                    Gestiona el stock
                </div>
                <div class="col-12 col-md-auto mobile--ver--sidebar">
                    <a href="{{ baseUrl }}tlib_gestion_stock.itx" class="btn btn-black-sidebar btn-sm">Acceder</a>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #incentivePendingModal let-modal>

    <div>
      <button type="button" class="close-incentive-img" aria-label="Cerrar" (click)="modal.dismiss()">
            <span aria-hidden="true">&times;</span>
      </button>

      <div class="position-absolute top-0 start-50 translate-middle-x mt-4 text-center" style="z-index: 10; width: 100%;">
        <h2 class="text-white fw-bold m-0">Nuevo incentivo</h2>
      </div>

      <ng-container *ngIf="isValidUrl(dataPoints.incentivePendingPopup.image); else noImage">
        <img [src]="dataPoints.incentivePendingPopup.image" alt="Incentivo pendiente" class="d-block w-100" style="height: auto; object-fit: cover;"/>
      </ng-container>
      <ng-template #noImage>
      <div  class="fallback-image-container d-flex align-items-center justify-content-center" style="height:300px; background-color:#3f3a3a; color:#ffffff;">
        Imagen de incentivo no disponible
      </div>
    </ng-template>

  </div>
</ng-template>
